export default "__VITE_ASSET__9fcd3647__"